import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/Warning';
import { Box, Stack, Typography, Avatar } from '@material-ui/core';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import MailIcon from '@mui/icons-material/Mail';
import FacebookIcon from '@mui/icons-material/Facebook';
import ShareIcon from '@mui/icons-material/Share';
import CommentIcon from '@mui/icons-material/Comment';
import { useSnackbar } from 'notistack5';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { useDispatch } from '../../../../redux/store';
import { newMessageFacebook, newMessageZalo } from '../../../../redux/slices/chat';
import { newMessageFacebookBySelectedContact } from '../../../../redux/slices/chat';
import { newMessageZaloBySelectedContact } from '../../../../redux/slices/chat';
const Item = styled(Paper)(({ theme }) => ({
    direction: "row",
    display: "flex",
    spacing: "10px",
    padding: "5px",
    justifyContent: "center",
    cursor: 'pointer'
}));
const ListItem = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 36,
    height: 36,
    border: `1px solid ${theme.palette.background.paper}`,
}));
export default function AlertFormListChat({ open, onClose, listChatContact }) {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();

    // const submit_merge_contact = async () => {
    //     try {
    //         const status_merge_contact = await apiContact.merge_contact({ uid: uid, phone: infoContactSelected.phone, type: type });
    //         enqueueSnackbar('Merge success', { variant: 'success' });
    //         setIsRefreshContact(true);
    //         onClose();
    //         onCloseForm();
    //     } catch (error) {
    //         enqueueSnackbar('Merge Failed', { variant: 'success' });
    //     }
    // }
    const onOpenConversation = (contact) => {
        if (contact.channel === "facebook") {
            dispatch(newMessageFacebookBySelectedContact(contact));
        }
        if (contact.channel === "zalo") {
            dispatch(newMessageZaloBySelectedContact(contact));
        }
    }
    return (
        <div>
            <Dialog
                open={open}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <Stack direction={"row"}>
                        <WarningIcon color="warning" />
                        <Typography>Thông báo</Typography>
                    </Stack>
                </DialogTitle>
                <DialogContent sx={{ mt: 2 }}>
                    <DialogContentText id="alert-dialog-description">
                        Người dùng của bạn đang sử dụng nhiều cuộc trò chuyện. Bạn có thể chọn cuộc trò chuyện!!!
                    </DialogContentText>
                    <DialogContentText id="alert-dialog-description">
                        <Paper sx={{ p: 1, gap: 1, display: 'flex', flexDirection: 'column' }}>
                            {listChatContact.map((contact, index) => {
                                if (contact.channel === "zalo") {
                                    return (
                                        <Stack justifyContent={"start"} direction="row" spacing={2} >
                                            <Item onClick={() => onOpenConversation(contact)}><SmallAvatar src="/static/icons/icons8-zalo.svg" sx={{ color: "rgb(25, 118, 210)" }} />  <Typography alignSelf={"center"} variant="body2" fontSize={"1em"} sx={{ color: 'text.secondary' }} >{contact.oa_id === contact.from_id ? contact.to_display_name : contact.from_display_name}</Typography> </Item>
                                            <Typography alignSelf={"center"} variant="body2" fontSize={"0.8em"} sx={{ color: 'text.secondary' }} > {contact.oa_id === contact.from_id ? contact.from_display_name : contact.to_display_name}</Typography>
                                        </Stack>
                                    )
                                }
                                if (contact.channel === 'facebook') {
                                    return (
                                        <Stack justifyContent={"start"} direction="row" spacing={1} >
                                            <Item onClick={() => onOpenConversation(contact)} ><SmallAvatar src="/static/icons/icons8-facebook.svg" sx={{ color: "rgb(25, 118, 210)" }} />  <Typography alignSelf={"center"} variant="body2" fontSize={"1em"} sx={{ color: 'text.secondary' }}>{contact.page_id === contact.from_id ? contact.to_display_name : contact.from_display_name}</Typography> </Item>
                                            <Typography alignSelf={"center"} variant="body2" fontSize={"0.8em"} sx={{ color: 'text.secondary' }}> {contact.page_id === contact.from_id ? contact.from_display_name : contact.to_display_name}</Typography>
                                        </Stack>
                                    );
                                }
                                return <></>
                            })}
                        </Paper>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Hủy bỏ</Button>
                    <Button autoFocus>
                        Đồng ý
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}